import apiLogin from '../api/apiLogin.js'
import apiUser from '../api/apiUser.js'
import apiLocation from '../api/apiLocation.js'
import apiTracker from '../api/apiTracker.js'
import store from '../store/index.js'
import bus from '../common/bus.js'
import router from '../router/index.ts'
import locationDataOptimizer from '../utils/locationDataOptimizer.js'
import apiOptimizationConfig from '../config/apiOptimization.js'
import realtimeMonitorLocationBootstrap from '../utils/realtimeMonitorLocationBootstrap'
import { calculateDeviceStatistics, collectAuthorizedDeviceSssids } from '../utils/deviceStatistics'
import { fields } from '@/shared/constants'
import {
  getRealtimeDriverInfoSssids,
  mergeRealtimeDriverInfo,
  preserveRealtimeDriverInfo,
} from '../utils/realtimeDriverInfo'

var userMap = new Map()
var trackerMap = new Map()
// 账号切换后递增，防止旧账号的异步定位响应污染当前统计。
var locationSessionVersion = 0
const { resetLocationBootstrapCache, resolveLocationRequestMode, markMissingTrackersOffline } =
  realtimeMonitorLocationBootstrap

var me = {
  callback: null,
  callbackMap: null,
  getRealtimeDriverSssids: null,
  autoUpdatePaused: false, // 控制自动更新是否暂停
  autoUpdateBusBound: false, // 暂停/恢复事件是否已注册
  sessionGeneration: 0,
  realtimeDriverRequestGeneration: 0,
  realtimeDriverRequests: new Map(),
  realtimeDriverSssidGenerations: new Map(),
  init: async function (that, callback) {
    // 监听批量命令对话框的暂停/恢复事件（只注册一次，避免重复进入布局时监听器堆积）
    if (!me.autoUpdateBusBound) {
      me.autoUpdateBusBound = true
      bus.$on('pauseAutoUpdate', () => {
        me.autoUpdatePaused = true
        console.log('✓ 自动更新已暂停（批量命令对话框打开）')
      })
      bus.$on('resumeAutoUpdate', () => {
        me.autoUpdatePaused = false
        console.log('✓ 自动更新已恢复（批量命令对话框关闭）')
      })
    }
    // that.GLOBAL.countsUpdateLocation = 0;
    // that.GLOBAL.tUpdateLocation = setTimeout(function () {
    // 	that.$Tools.log(":userInfo",that.GLOBAL.userInfo)
    //     me.TimingUpdateLocation(that)
    //  }, 2000);
    if (that.GLOBAL.userInfo != null) {
      if (that.GLOBAL.userInfo.users != undefined) {
        that.$Tools.log('数据已完善:userInfo', that.GLOBAL.userInfo)
      } else {
        that.$Tools.log('不重新登陆 获取子账号信息', that.GLOBAL.userInfo)
        me.startGetUsers(that)
      }
      // 加载命令权限
      me.loadCommandPermission()
      callback(true)
    } else {
      that.$Tools.log('没有登陆直接访问的，需要重新登陆')
      var parm = {
        language: localStorage.getItem('language'),
        timezone: parseInt(localStorage.getItem('timezone')),
        useraccount: localStorage.getItem('useraccount'),
        password: localStorage.getItem('password'),
      }
      // formData格式转换
      var formData = new FormData()
      formData.append('language', parm.language)
      formData.append('timezone', parm.timezone)
      formData.append('useraccount', parm.useraccount)
      formData.append('password', parm.password)

      if (parm.useraccount != '' && parm.password != '') {
        return await apiLogin.possLogin(formData).then((msg) => {
          if (msg.state == true) {
            //that.$message.success('登录成功');
            localStorage.setItem('ms_token', msg.value.userToken)
            localStorage.setItem('useraccount', parm.useraccount)
            localStorage.setItem('password', parm.password)
            that.GLOBAL.userInfo = msg.value
            that.$Tools.log('登陆后获取子账号信息')
            me.startGetUsers(that)
            // 登录后强制刷新命令权限
            me.loadCommandPermission(true)
            callback(true)
          } else {
            callback(false)
          }
        })
      } else {
        callback(false)
      }
    }
  },

  // 加载命令权限（force: 是否强制刷新，默认 false 使用缓存）
  loadCommandPermission: function (force = false) {
    store.dispatch('permission/LoadCommandPermission', { force })
  },

  async startGetUsers(that) {
    locationSessionVersion++
    const sessionId = ++me.sessionGeneration
    const account = that.GLOBAL.userInfo.sssid

    me.realtimeDriverRequests.clear()
    me.realtimeDriverSssidGenerations.clear()

    resetLocationBootstrapCache({ trackerMap, userMap })
    that.GLOBAL.trackerMap = new Map()

    userMap.set(account, that.GLOBAL.userInfo)

    // 注意：位置请求必须等 GetSimpleUser 返回后再发，不能与之并发。
    // 服务端 PUser 缓存未命中时会走 RebuildPUserFromDb 从库里重建（一次 User_Tracker_View
    // 全量查询，实测均值 4.8s），且重建结果传 needSaveRedis=false 并不回写缓存。
    // 两个接口并发打过去 = 同时触发两次这样的重建，没有单飞保护，直接把 DB 打满。
    return new Promise((resolve) => {
      me.getuser(that, account, function () {
        if (sessionId !== me.sessionGeneration || that.GLOBAL.userInfo?.sssid !== account) {
          resolve(that.GLOBAL.userInfo)
          return
        }

        that.$Tools.log(
          '账号获取完了:',
          new Date(),
          that.GLOBAL.userInfo.nickName,
          that.GLOBAL.userInfo.sssid,
          that.GLOBAL.userInfo
        )
        that.GLOBAL.countsUpdateLocation = 0
        that.GLOBAL.tUpdateLocation = setTimeout(function () {
          if (sessionId !== me.sessionGeneration || that.GLOBAL.userInfo?.sssid !== account) return
          if (!me.TimingUpdateRoute()) {
            me.getAllLastLocationsSpc(that, null, { sessionId })
          }
          me.TimingUpdateLocation(that, sessionId)
        }, 100)
        resolve(that.GLOBAL.userInfo)
      })
    })

    // a.then((res) => {

    // 	that.$Tools.log("账号获取完了:",res,new Date(),that.GLOBAL.userInfo.nickName,that.GLOBAL.userInfo.sssid,that.GLOBAL.userInfo)

    // })
  },

  exitLogin: function (that) {
    me.sessionGeneration += 1
    me.callback = null
    me.callbackMap = null
    me.getRealtimeDriverSssids = null
    me.autoUpdatePaused = false
    me.realtimeDriverRequests.clear()
    me.realtimeDriverSssidGenerations.clear()

    // 清除定时器，避免退出后继续请求
    if (that.GLOBAL && that.GLOBAL.tUpdateLocation) {
      clearTimeout(that.GLOBAL.tUpdateLocation)
      that.GLOBAL.tUpdateLocation = null
    }

    locationSessionVersion++
    resetLocationBootstrapCache({ trackerMap, userMap })
    if (that.GLOBAL) {
      that.GLOBAL.trackerMap = new Map()
    }

    localStorage.setItem('ms_token', '')
    localStorage.setItem('password', '')
    // 会话恢复现在真的会读这份数据，登出时必须清掉，否则本地留着上一个账号的用户信息
    localStorage.removeItem(fields.userInfo)
    localStorage.removeItem('userInfo')

    that.$router.push('/loginPage')
  },

  getuser: async function (that, sAccount, callback, sessionId = me.sessionGeneration) {
    var info = userMap.get(sAccount)
    const requestSessionVersion = locationSessionVersion
    var parm = {
      sAccouont: sAccount,
    }

    //admin获取所有未授权或授权tracker
    // if (that.GLOBAL.userInfo.account == "admin") {
    //     parm.access = "";
    // }

    return await apiUser.GetSimpleUser(parm).then((res) => {
      if (
        sessionId !== me.sessionGeneration ||
        requestSessionVersion !== locationSessionVersion ||
        String(that.GLOBAL.userInfo?.sssid) !== String(sAccount)
      ) {
        console.warn('忽略过期的用户树响应:', {
          requestUserSssid: sAccount,
          currentUserSssid: that.GLOBAL.userInfo?.sssid,
          requestSessionVersion,
          currentSessionVersion: locationSessionVersion,
        })
        callback(true)
        return
      }
      if (res.state == true) {
        Object.assign(info, res.value)
        // 总数来自最新账号树，不必等待定位接口（新设备可能尚未上线）。
        store.dispatch('settings/updateDeviceStatistics', {
          totalDevices: collectAuthorizedDeviceSssids(info).size,
        })
        bus.$emit('updateUserInfo', info)
        callback(true)
        // if (info.users.length == 0) {
        // 	//that.$Tools.log("该账号没有子账号了",new Date,info.nickName,info.sssid)
        // 	callback(true)
        // } else {
        // 	var count = 0;
        // 	for (let i = 0; i < info.users.length; i++) {
        // 		userMap.set(info.users[i].sssid, info.users[i])
        // 		me.getuser(that, info.users[i].sssid, function () {
        // 			count++;
        // 			if (count == info.users.length) {
        // 				//that.$Tools.log("该账号的子账号获取完了",new Date,info.nickName,info.sssid)
        // 				callback(true)
        // 			}
        // 		})
        // 	}
        // }
      } else {
        // 获取失败（如弱网/超时）：沿用现有数据继续初始化，避免页面永久卡在加载
        console.warn('GetSimpleUser 获取用户信息失败，沿用现有数据继续初始化:', res)
        callback(true)
      }
    }).catch((error) => {
      // 请求异常（超时等）：同样放行，定时循环会在后续轮次重试
      console.error('GetSimpleUser 请求失败，沿用现有数据继续初始化:', error)
      callback(true)
    })
    // return await apiUser.GetSubUsersTrackers(parm).then(res => {
    // 	if (res.state == true) {
    // 		info.trackers = res.value.trackers
    // 		info.users = res.value.users
    // 		if (info.users.length == 0) {
    // 			//that.$Tools.log("该账号没有子账号了",new Date,info.nickName,info.sssid)
    // 			callback(true)
    // 		} else {
    // 			var count = 0;
    // 			for (let i = 0; i < info.users.length; i++) {
    // 				userMap.set(info.users[i].sssid, info.users[i])
    // 				me.getuser(that, info.users[i].sssid, function () {
    // 					count++;
    // 					if (count == info.users.length) {
    // 						//that.$Tools.log("该账号的子账号获取完了",new Date,info.nickName,info.sssid)
    // 						callback(true)
    // 					}
    // 				})
    // 			}
    // 		}
    // 	}
    // })
  },

  TimingUpdateRoute: function () {
    if (
      router.currentRoute.path === '/loginPage' ||
      router.currentRoute.path === '/realTimeMonitor' ||
      router.currentRoute.path === '/videoMonitor' ||
      router.currentRoute.path === '/trackPlayback' ||
      router.currentRoute.path === '/videoPlayback' ||
      router.currentRoute.path === '/playback' ||
      router.currentRoute.path === '/statisticalReport' ||
      router.currentRoute.path === '/infoManagement' ||
      router.currentRoute.path === '/ruleManagement'
    ) {
      return true
    } else {
      return false
    }
  },

  TimingUpdateLocation: function (that, sessionId = me.sessionGeneration) {
    if (sessionId !== me.sessionGeneration) return

    clearTimeout(that.GLOBAL.tUpdateLocation) //清除定时器
    //that.$Tools.log("倒计时：",that.GLOBAL.countsUpdateLocation,new Date())
    if (that.GLOBAL.countsUpdateLocation <= 0) {
      if (this.TimingUpdateRoute()) {
        this.getAllLastLocationsSpc(that, null, { sessionId })
      }

      let data = store.getters.realtimeSettingData || store.getters.realtimeSettingDefaultData
      const time = data.dataRefreshTimeSelected
      that.GLOBAL.countsUpdateLocation = time - 1
      console.log(time)
      that.GLOBAL.tUpdateLocation = setTimeout(function () {
        me.TimingUpdateLocation(that, sessionId)
      }, 1000)
      // apiLocation.GetAllLastLocations().then(res => {
      // 	if (res.state == true) {
      // 		for (let i = 0; i < res.value.length; i++) {
      // 			let tarcks = res.value[i];
      // 			if (tarcks.tracker != undefined) {
      // 				trackerMap.set(tarcks.tracker.sssid, tarcks);
      // 			}
      // 		}
      // 		that.GLOBAL.trackerMap = trackerMap
      // 		that.$Tools.log("设备位置信息：", that.GLOBAL.trackerMap);
      // 		if (me.callback != null) {
      // 			me.callback(that.GLOBAL.userInfo);
      // 		}
      // 		if (me.callbackMap != null) {
      // 			me.callbackMap(trackerMap);
      // 		}
      // 	}

      // 	that.GLOBAL.countsUpdateLocation = 10;
      // 	that.GLOBAL.tUpdateLocation = setTimeout(function () {
      // 		me.TimingUpdateLocation(that);
      // 	}, 2000);
      // })
    } else {
      that.GLOBAL.countsUpdateLocation--
      that.GLOBAL.tUpdateLocation = setTimeout(function () {
        me.TimingUpdateLocation(that, sessionId)
      }, 1000)
    }
  },

  async enrichRealtimeDriverInfo(that, sessionId, account, trackerLocations) {
    if (router.currentRoute.path !== '/realTimeMonitor') return false

    const sourceTrackerLocations = Array.isArray(trackerLocations)
      ? trackerLocations
      : [...trackerMap.values()]
    const selectedSssids =
      trackerLocations === undefined && typeof me.getRealtimeDriverSssids === 'function'
        ? me.getRealtimeDriverSssids()
        : null
    const ssidArray = getRealtimeDriverInfoSssids(sourceTrackerLocations, selectedSssids)
    if (ssidArray.length === 0) return false
    const requestKey = `${account}:${ssidArray.map(String).sort().join(',')}`
    let requestEntry = me.realtimeDriverRequests.get(requestKey)
    if (
      requestEntry &&
      ssidArray.some(
        (sssid) =>
          me.realtimeDriverSssidGenerations.get(String(sssid)) !== requestEntry.generation
      )
    ) {
      requestEntry = null
    }
    if (!requestEntry) {
      const requestGeneration = ++me.realtimeDriverRequestGeneration
      ssidArray.forEach((sssid) => {
        me.realtimeDriverSssidGenerations.set(String(sssid), requestGeneration)
      })
      requestEntry = {
        generation: requestGeneration,
        promise: apiTracker.getTrackerRFIDDrivers(ssidArray),
      }
      me.realtimeDriverRequests.set(requestKey, requestEntry)
    }

    try {
      const res = await requestEntry.promise
      if (
        sessionId !== me.sessionGeneration ||
        router.currentRoute.path !== '/realTimeMonitor' ||
        String(that.GLOBAL.userInfo?.sssid) !== String(account)
      ) {
        return false
      }
      if (res && res.state === true) {
        // A newer location response may have replaced these objects while the
        // RFID request was in flight. Always enrich the current cache entries.
        const requestedSssidSet = new Set(
          ssidArray
            .map((ssid) => String(ssid))
            .filter(
              (sssid) =>
                me.realtimeDriverSssidGenerations.get(sssid) === requestEntry.generation
            )
        )
        if (requestedSssidSet.size === 0) return false
        const currentTrackerLocations = [...trackerMap.entries()]
          .filter(([sssid]) => requestedSssidSet.has(String(sssid)))
          .map(([, location]) => location)
        const mergeTargets = [...currentTrackerLocations]
        sourceTrackerLocations.forEach((location) => {
          const sssid = getRealtimeDriverInfoSssids([location])[0]
          if (
            requestedSssidSet.has(String(sssid)) &&
            !mergeTargets.includes(location)
          ) {
            mergeTargets.push(location)
          }
        })
        const currentRecords = Array.isArray(res.value)
          ? res.value.filter((record) => requestedSssidSet.has(String(record?.ssid)))
          : res.value
        mergeRealtimeDriverInfo(mergeTargets, currentRecords)
        return true
      }
    } catch (error) {
      console.warn('获取实时司机信息失败，继续使用定位数据:', error)
    } finally {
      if (me.realtimeDriverRequests.get(requestKey) === requestEntry) {
        me.realtimeDriverRequests.delete(requestKey)
      }
    }
    return false
  },

  getAllLastLocationsSpc(that, myCallback, options = {}) {
    const sessionId = options.sessionId ?? me.sessionGeneration
    const account = that.GLOBAL?.userInfo?.sssid

    if (sessionId !== me.sessionGeneration) return

    // 如果自动更新被暂停，则不执行GetAllLastLocations
    if (me.autoUpdatePaused) {
      console.log('⏸ 自动更新被暂停，跳过本次GetAllLastLocations调用')
      return
    }

    let data = store.getters.generalSettingData || store.getters.generalSettingDefaultData
    const requestSessionVersion = locationSessionVersion
    const requestUserSssid = that.GLOBAL.userInfo?.sssid

    const { isFirstLoad, onlyOnline } = resolveLocationRequestMode({
      trackerMapSize: trackerMap.size,
      overrideOnlyOnline: options.onlyOnline,
    })

    // 基础参数
    var p = {
      onlinePlanPar: {
        type: data.VehicleOnline.onlineType,
        onlineType: data.VehicleOnline.onlineType,
        onlineInterval: data.VehicleOnline.onlineTime,
        onlineIridiumInterval: data.VehicleOnline.onlineIridiumInterval || 4320,
        isOfflineWhenSleep: data.VehicleOnline.sleepOffline,
        positioningSpeedOffline: data.VehicleOnline.positioningSpeedOffline,
        offlineSpeedCondition: data.VehicleOnline.positioningSpeedBetween.km,
        offlineTimeCondition: data.VehicleOnline.positioningSpeedBetween.min,
        offlineGapCondition:
          data.VehicleOnline.positioningSpeedBetween.gap || 20, //断档时间,旧存储无此字段时用默认20
      },
      vehicleParkingPar: {
        isEnable: data.VehicleStop.positioningSpeed,
        speed: data.VehicleStop.km,
      },
      // 新增优化参数
      // 首次加载获取所有设备（包括离线），后续只获取在线设备（除非明确指定）
      onlyOnline,
      compress: true, // 启用数据压缩
      fields: options.fields || [
        // 默认字段列表，可通过 options 覆盖
        // tracker 必需字段
        'tracker.sssid',
        'tracker.name',
        'tracker.imei',
        'tracker.typeName',
        'tracker.objectTypeId',
        'tracker.protocol',
        'tracker.color',
        'tracker.icon',
        'tracker.image',
        'tracker.locked',
        'tracker.expTime',
        'tracker.carNumber',
        'tracker.driverName',
        'obdData',
        // lastLoc 必需字段
        'lastLoc.latitude',
        'lastLoc.longitude',
        'lastLoc.speed',
        'lastLoc.direction',
        'lastLoc.address',
        'lastLoc.gpsAvailable',
        'lastLoc.gsmLatitude',
        'lastLoc.gsmLongitude',
        'lastLoc.stationID',
        'lastLoc.online',
        'lastLoc.receivedTime',
        'lastLoc.battery',
        'lastLoc.gsmsignal',
        'lastLoc.eventId',
        'lastLoc.eventName',

        // 报警信息
        'lastAlarm',
      ],
    }

    // 根据不同页面可能需要不同的字段
    const currentRoute = router.currentRoute.path
    if (currentRoute === '/realTimeMonitor' || currentRoute === '/videoMonitor') {
      // 实时监控和视频监控页面需要更多字段
      if (!options.fields) {
        p.fields.push('lastLoc.keyValues', 'lastLoc.journeyStr', 'lastLoc.wifi', 'lastLoc.ble')
      }
    }

    console.log('GetAllLastLocations 请求参数优化：', {
      isFirstLoad,
      onlyOnline: p.onlyOnline,
      fieldCount: p.fields.length,
      compress: p.compress,
      totalTrackers: trackerMap.size,
    })

    localStorage.setItem('onlinePar', JSON.stringify(p))

    apiLocation.GetAllLastLocations(p).then(async (res) => {
      // 账号已切换或用户上下文已变化时，忽略旧请求结果。
      if (
        sessionId !== me.sessionGeneration ||
        requestSessionVersion !== locationSessionVersion ||
        String(that.GLOBAL.userInfo?.sssid) !== String(requestUserSssid)
      ) {
        console.warn('忽略过期的定位响应:', {
          requestUserSssid,
          currentUserSssid: that.GLOBAL.userInfo?.sssid,
          requestSessionVersion,
          currentSessionVersion: locationSessionVersion,
        })
        if (myCallback) myCallback()
        return
      }
      if (res.state == true) {
        if (onlyOnline) {
          markMissingTrackersOffline({
            trackerMap,
            onlineTrackerLocations: res.value,
          })
        }

        // 获取长时间离线设置
        const isLongOfflineEnabled = data.VehicleOnline?.longOfflineTimeEnable || false
        const longOfflineTime = data.VehicleOnline?.longOfflineTime || 1440 // 默认1440分钟(24小时)

        for (let i = 0; i < res.value.length; i++) {
          let tarcks = res.value[i]
          if (tarcks.tracker != undefined) {
            if (tarcks.lastLoc && tarcks.obdData && tarcks.obdData['CAN0XA04B']) {
              tarcks.lastLoc.currentNetwork = tarcks.obdData['CAN0XA04B'].value
            }
            preserveRealtimeDriverInfo(trackerMap.get(tarcks.tracker.sssid), tarcks)
            trackerMap.set(tarcks.tracker.sssid, tarcks)
          }
        }

        const authorizedSssids = collectAuthorizedDeviceSssids(that.GLOBAL.userInfo)
        const { totalDevices, onlineDevices, alarmDevices, longOfflineDevices } =
          calculateDeviceStatistics([...trackerMap.values()], {
            authorizedSssids,
            longOfflineTimeEnable: isLongOfflineEnabled,
            longOfflineTime,
          })

        console.log('Updating statistics:', {
          totalDevices,
          onlineDevices,
          alarmDevices,
          longOfflineDevices,
          longOfflineEnabled: isLongOfflineEnabled,
          longOfflineTimeMinutes: longOfflineTime,
        })

        // 更新 Vuex store
        store.dispatch('settings/updateDeviceStatistics', {
          totalDevices,
          onlineDevices,
          alarmDevices,
          longOfflineDevices,
        })

        that.GLOBAL.trackerMap = trackerMap

        // 只查询实时监控当前选中的设备。后台加载司机信息，不再 await——
        // RFID 接口慢时曾把整轮位置刷新回调（marker/树/统计）拖慢近10秒。
        me.enrichRealtimeDriverInfo(that, sessionId, requestUserSssid)
        if (
          sessionId !== me.sessionGeneration ||
          locationSessionVersion !== requestSessionVersion ||
          String(that.GLOBAL.userInfo?.sssid) !== String(requestUserSssid)
        ) {
          if (myCallback) myCallback()
          return
        }

        if (me.callback != null) {
          me.callback(that.GLOBAL.userInfo)
        }
        if (me.callbackMap != null) {
          me.callbackMap(trackerMap)
        }

        bus.$emit('updateAllLocation', that.GLOBAL.userInfo)
      }
      if (myCallback) {
        myCallback()
      }
    }).catch((error) => {
      if (sessionId === me.sessionGeneration) {
        console.warn('GetAllLastLocations 请求失败，等待下一轮重试:', error)
      }
      if (myCallback) {
        myCallback()
      }
    })
  },
}
export default me
